<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="store"
            name="name"
            v-model="form.name"
            :label="$t('delivery.branch.labels.name')"
            :placeholder="$t('delivery.branch.labels.name')"
            :error="hasInputErrors('name')"
            :error-messages="getInputErrors('name')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="verified"
            name="isDefault"
            v-model="form.isDefault"
            :label="$t('delivery.branch.labels.isDefault')"
            :placeholder="$t('delivery.branch.labels.isDefault')"
            :error="hasInputErrors('isDefault')"
            :error-messages="getInputErrors('isDefault')"
            color="secondary"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="12">
      <location-form
          v-model="form.location"
          map-height="200px"
          :address-sm-col="12"
          :apartment-sm-col="6"
          :floor-sm-col="6"
          :map-sm-col="12"
          :address-first="false"
          :enable-locality-combobox="true"
      ></location-form>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
import LocationForm from "@/modules/maps/components/LocationForm/LocationForm";

export default {
  name: "BranchForm",
  components: {LocationForm},
  mixins: [InputErrorsByProps, RequiredRule],

  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>

